/**
 * @generated SignedSource<<bbb2d2af111b05657ff78ffbfbdc3647>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type MusicChangePieceNameInput = {
  name: string;
  piece_id: string;
};
export type ChangeMusicPieceNameMutation$variables = {
  input: MusicChangePieceNameInput;
};
export type ChangeMusicPieceNameMutation$data = {
  readonly music_change_piece_name: {
    readonly piece: {
      readonly id: string;
      readonly name: string | null;
    };
  };
};
export type ChangeMusicPieceNameMutation = {
  variables: ChangeMusicPieceNameMutation$variables;
  response: ChangeMusicPieceNameMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "MusicPieceOutput",
    "kind": "LinkedField",
    "name": "music_change_piece_name",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "MusicPiece",
        "kind": "LinkedField",
        "name": "piece",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ChangeMusicPieceNameMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ChangeMusicPieceNameMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "247d84068e32baf9fd1cb6e21829d439",
    "id": null,
    "metadata": {},
    "name": "ChangeMusicPieceNameMutation",
    "operationKind": "mutation",
    "text": "mutation ChangeMusicPieceNameMutation(\n  $input: MusicChangePieceNameInput!\n) {\n  music_change_piece_name(input: $input) {\n    piece {\n      id\n      name\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "aec8691cd3df5971d88e2c474d174653";

export default node;
